"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthData = getAuthData;
exports.getOAuth2Data = getOAuth2Data;
exports.updateOAuthSettings = updateOAuthSettings;
function getAuthData(settings) {
    const oauthData = getOAuth2Data(settings);
    return {
        accessToken: oauthData.accessToken,
        refreshToken: oauthData.refreshToken,
        refreshTokenUrl: oauthData.refreshTokenUrl
    };
}
function getOAuth2Data(settings) {
    const { oauth } = settings;
    return {
        accessToken: oauth?.access_token,
        refreshToken: oauth?.refresh_token,
        clientId: oauth?.clientId,
        clientSecret: oauth?.clientSecret,
        refreshTokenUrl: oauth?.refresh_token_url
    };
}
function updateOAuthSettings(settings, oauthData) {
    const { oauth, ...otherSettings } = settings;
    if (oauth) {
        const newOauth = oauth;
        newOauth.access_token = oauthData.accessToken;
        if (oauthData.refreshToken) {
            newOauth.refresh_token = oauthData.refreshToken;
        }
        otherSettings['oauth'] = newOauth;
    }
    return otherSettings;
}
//# sourceMappingURL=parse-settings.js.map